<svelte:options accessors={true} />

<script lang="ts">
  import {Icon} from '@components';

  export let value: any = null;
  export let error: string = '';
  let label: any = 'Click to choose a video';

  const selectVideo = (e: any) => {
    value = e.target.files[0];
    label = value.name;
    error = '';

    if (!value.type.includes('video')) {
      error = "You're trying to upload a different file. Please download only video file types.";
      return;
    }

    if (!value.type.includes('quicktime') && !value.type.includes('mp4')) {
      error = 'We currently only accept mp4 and mov video files';
    }
  };
</script>

<div class="flex-grow">
  <label for="file-upload">
    <div><Icon name="Video" className="w-10 text-gray-400" /></div>
    <div class="text-center text-sm">{label}</div>
  </label>

  <input type="file" class="hidden" id="file-upload" name="file" accept="video/*" on:change={selectVideo} />
</div>

<style lang="postcss">
  label {
    @apply mb-2 cursor-pointer rounded p-8;
    @apply border-2 border-dashed border-gray-300 bg-white;
    @apply flex w-full flex-col items-center justify-center gap-3 transition-colors;
  }

  label:hover {
    @apply bg-gray-100;
  }
</style>
